import React, { useEffect } from 'react'
import { Typography } from '../layout/Typography'
import { Box } from '../layout/Box'
import { checkIfAppointmentCanBeCanceled, cancelAppointment } from './api'
import { getGuidFromUrlParams } from '../../utils/urlParams'
import { ErrorPage } from '../data/ErrorPage'
import { ActionButton } from '../../styles/components/buttons'
import { RouteType } from '../../types/routes'
import { Link } from '../layout/Link'

export const CancelAppointment: React.FC = () => {
  const [error, setError] = React.useState<string | null>(null)
  const [submitted, setSubmitted] = React.useState(false)

  useEffect(() => {
    const checkAppointment = async () => {
      const guid = getGuidFromUrlParams()

      if (!guid) {
        setError('Termin guid nicht gefunden')
        return
      }

      const response = await checkIfAppointmentCanBeCanceled(guid)

      if (!response) {
        setError('Termin nicht gefunden')
      }
    }

    checkAppointment()
  }, [])

  const handleCancelAppointmentClick = async () => {
    const guid = getGuidFromUrlParams()

    const response = await cancelAppointment(guid)

    if (!response) {
      setError('Termin konnte nicht abgesagt werden')
      return
    }

    setError(null)
    setSubmitted(true)
  }

  if (error) {
    return <ErrorPage errors={error} />
  }

  return (
    <Box>
      <Typography variant="h4">Termin absagen</Typography>
      <Box flex flexDirection="column" centerHorizontal>
        {submitted ? (
          <>
            <Typography variant="bold">Der Termin wurde erfolgreich abgesagt.</Typography>

            <Link to={RouteType.Home}>
              <ActionButton>Zurück zur Startseite</ActionButton>
            </Link>
          </>
        ) : (
          <>
            <Typography variant="body1">Möchten Sie den Termin wirklich absagen?</Typography>

            <ActionButton onClick={() => handleCancelAppointmentClick()}>Termin absagen</ActionButton>
          </>
        )}
      </Box>
    </Box>
  )
}
